module.exports = __webpack_public_path__ + "static/media/verified.cebf6cec.png";